module.exports = __webpack_public_path__ + "img/img_supplier_fk@2x.9b466c18.png";